
<div class="py-4 px-5">

    <div class="d-flex justify-content-center mb-3">
        <h2 class="heading-text">{{'Common.PayDetails'|translate}}</h2>
    </div>
    
    @for (item of infoList; track $index) {
        <div class="d-flex justify-content-between mb-2">
            <label class="color-dark" style="font-weight:700;"> {{item.label|translate}}  </label> 
            <span> {{item.data ?? '--'}}</span> 
        </div>
    }
    <!-- Action Buttons -->
    <div class="d-flex justify-content-center mt-3 mb-1">
       <app-action-buttons [searchLabel]="'Common.Discard'" [showDiscard]="false" (onSubmit)="modalService.dismissAll()"></app-action-buttons>
    </div>
</div>